import ProductsComponent from '../../components/productsComponent/products';
export default function ProductsPage() {
	return <ProductsComponent />;
}
